import { RouteToPageNameMap } from '../types';
import { RouteNames } from './routes';

export const ROUTE_TO_PAGE_NAME: RouteToPageNameMap = {
  [RouteNames.TICKET_TYPES]: 'page_ticket_types',
  [RouteNames.TICKET_SELECTOR]: 'page_ticket_selector',
  [RouteNames.BOOKING_SUMMARY]: 'page_travel_details',
  [RouteNames.FLEXIBLE_TICKETS]: 'page_ticket_results',
  [RouteNames.PAYG_TICKETS]: 'page_ticket_results',
  [RouteNames.SEARCH_RESULT_TICKETS]: 'page_ticket_results',
  [RouteNames.BOOKING_CONFIRMATION]: 'booking_confirmation_title',
  [RouteNames.CUSTOMER_DETAILS]: 'page_my_account',
  [RouteNames.DIRECT_DEBIT]: 'page_direct_debit',
  [RouteNames.POST_LOGIN]: 'post_login',
  [RouteNames.PAYMENT_FAILED]: 'payment_failed',
  [RouteNames.PAYMENT_SUCCESS]: 'payment_success',
  [RouteNames.PAGE_NOT_FOUND]: '',
};
